import { apiClient } from "../../../api/apiClient";

export async function getPostingsAsync(params = {}) {
  const defaultParams = {
    sort: '["createdAt","DESC"]',
    ...params,
  };

  const response = await apiClient().get(`communications/postings`, {
    params: defaultParams,
  });

  return response && response.data ? response.data : null;
}

export async function getPostingsByEstateIdAsync(estateId) {
  return getPostingsAsync({ filter: `{"estateId": ${estateId}}` });
}
